module.exports = __webpack_public_path__ + "img/ruffle_length.80722a4f.png";